import request from '../request'

/*
  订单相关接口
  331542    获取订单列表
  331540    删除订单
*/
export default {
  '331542': () =>
    request.ticket({
      url: '/gateway/gtgj/daigou',
      auth: 'yes',
      data: {
        pid: 331542
      },
      sidFields: ['uid', 'pid']
    }),
  // type: 1抢票，2代购
  '331540': ({
      orderId,
      type
    }) =>
    request.ticket({
      url: '/gateway/gtgj/daigou',
      auth: 'yes',
      data: {
        pid: 331540,
        orderId,
        type
      },
      sidFields: ['uid', 'pid']
    }),
  '331018': () => {
    return request.ticket({
      url: '/gateway/gtgj/daigou',
      auth: 'yes',
      data: {
        pid: 331018
      },
      sidFields: ['uid', 'pid']
    })
  },
  '331019': (orderId) => {
    return request.ticket({
      url: '/gateway/gtgj/daigou',
      auth: 'yes',
      data: {
        pid: 331019,
        orderId: orderId
      },
      sidFields: ['uid', 'pid']
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/order.js